<template>
  <div id="hres6ke">
    <hrms-search-box-table v-show="indexDisp"
            v-model="searchParams"
            :data="index"
            :nowLang="app.nowLang"
            :unLoadBool="true"
            :columns="columns[app.nowLang].index"
            :receivedStore="receivedHres6keIndex"
            searchBoxAlias="request"
            :addEvent="addEvent"
            :editEvent="editEvent"
            :cancelEvent="cancelEvent" />
    <detail v-if="detailDisp"
            :labels="labels[app.nowLang]"
            :labelsButton="app.button[app.nowLang]"
            :detail="detail"
            :currentDtereq="currentDtereq"
            :currentNumseq="detail.numseq"
            :currentCodempid="codempid"
            :nowLang="app.nowLang"
            :toggle="toggle"
            :postHres6keSave="postHres6keSave"
            :indexSelected="indexSelected"
            :arrCodrem="dropdowns.codrem"
            :searchParams="searchParams"
            :descCodapp="dash.descCodapp"
            :receivedHres6keIndex="receivedHres6keIndex" />
  </div>
</template>

<script>
import { mapGetters, mapMutations, mapActions } from 'vuex'
import * as types from 'store/modules/hres6ke/mutation-types'
import detail from 'components/hres6ke/detail'
import moment from 'moment'
import swal from 'sweetalert'
import { constLabels } from 'assets/js/constLabels.js'

export default {
  name: 'hres6ke',
  data () {
    return {
      app: this.$parent.$parent.$parent,
      dash: this.$parent.$parent.$parent.$children[0],
      currentDtereq: moment().format('DD/MM/YYYY'),
      searchParams: {
        dtereqst: '01/01/' + moment().format('YYYY'),
        dtereqen: moment().format('DD/MM/YYYY')
      }
    }
  },
  created () {
    this.receivedHres6keColumnsLabels()
    this.receivedHres6keDropdowns()
  },
  computed: {
    codempid () {
      let currentUser = this.app.currentUser
      return currentUser.p_codempid
    },
    ...mapGetters({
      indexDisp: types.GET_HRES6KE_INDEX_DISP,
      detailDisp: types.GET_HRES6KE_DETAIL_DISP,
      columns: types.GET_HRES6KE_COLUMNS,
      labels: types.GET_HRES6KE_LABELS,
      index: types.GET_HRES6KE_INDEX,
      indexSelected: types.GET_HRES6KE_INDEX_SELECTED,
      detail: types.GET_HRES6KE_DETAIL,
      dropdowns: types.GET_HRES6KE_DROPDOWNS
    })
  },
  methods: {
    pageDetail (event) {
      switch (event) {
        case 'add':
          let searchParams = {
            p_dtework: moment().format('DD/MM/YYYY')
          }
          this.receivedHres6keCreate(searchParams)
          this.currentDtereq = moment().format('DD/MM/YYYY')
          this.toggle('detail')
          break
        case 'edit':
          if (this.indexSelected.numseq) {
            if (this.indexSelected.staappr === 'A' || this.indexSelected.staappr === 'Y' || this.indexSelected.staappr === 'N') {
              swal({
                title: constLabels('warningTitle'),
                text: constLabels('HR1490'),
                confirmButtonText: constLabels('ok')
              })
            }
            this.currentDtereq = this.indexSelected.dtereq
            let searchParams = {
              p_dtereq: this.indexSelected.dtereq,
              p_numseq: this.indexSelected.numseq
            }
            this.receivedHres6keDetail(searchParams)
            this.toggle('detail')
          }
          break
        default:
          break
      }
    },
    addEvent (param) {
      this.pageDetail('add')
    },
    editEvent (param) {
      this.setIndexSelected(param)
      this.pageDetail('edit')
    },
    cancelEvent (param) {
      this.setIndexSelected(param)
      if (this.indexSelected.staappr === 'P') {
        let sendParams = {
          codempid: this.indexSelected.codempid,
          dtereq: this.indexSelected.dtereq,
          numseq: this.indexSelected.numseq,
          staappr: this.indexSelected.staappr
        }
        this.postHres6keCancel({ cancelParams: sendParams, searchParams: this.searchParams })
      } else if (this.indexSelected.staappr === 'C') {
        swal({
          title: constLabels('warningTitle'),
          text: constLabels('HR1506'),
          confirmButtonText: constLabels('ok')
        })
      } else {
        swal({
          title: constLabels('warningTitle'),
          text: constLabels('HR1490'),
          confirmButtonText: constLabels('ok')
        })
      }
    },
    ...mapMutations({
      setIndexSelected: types.SET_HRES6KE_INDEX_SELECTED
    }),
    ...mapActions({
      toggle: types.TOGGLE_HRES6KE_PAGE,
      receivedHres6keColumnsLabels: types.RECEIVED_HRES6KE_COLUMNS_LABELS,
      receivedHres6keDropdowns: types.RECEIVED_HRES6KE_DROPDOWNS,
      receivedHres6keIndex: types.RECEIVED_HRES6KE_INDEX,
      receivedHres6keCreate: types.RECEIVED_HRES6KE_CREATE,
      receivedHres6keDetail: types.RECEIVED_HRES6KE_DETAIL,
      postHres6keSave: types.POST_HRES6KE_SAVE,
      postHres6keCancel: types.POST_HRES6KE_CANCEL
    })
  },
  components: {
    detail
  }
}
</script>


// WEBPACK FOOTER //
// component.vue?f4db5c2c